import React from 'react'
import {NullAsDefault, renderOwnChild} from 'views/Shared'
import {ObserverProvider} from 'views/Shared/components/ObservedList'
import {ModuleLayoutWrapper} from './createModule'

const createModuleLayout =
    ({
         top,
         bottom,
         Nav = NullAsDefault,
         Sider = NullAsDefault,
         Banner = NullAsDefault,
         visibleLeftDrawer = false,
         Template = renderOwnChild,
         ...props
     }) =>
        (content) =>
            (
                <ObserverProvider>
                    <ModuleLayoutWrapper
                        Header={NullAsDefault}
                        visibleLeftDrawer={visibleLeftDrawer}>
                        {top}
                        <Template
                            Sider={Sider}
                            Banner={Banner}
                            {...props}>
                            {content}
                        </Template>
                        {bottom}
                    </ModuleLayoutWrapper>
                </ObserverProvider>
            )

export default createModuleLayout
